import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import './css/ModernAuditionCard.css';

const ModernAuditionCard = ({ audition }) => {
  if (!audition) return null;

  // Map keys from your new JSON response
  const id = audition.id || audition.jogetRoleId;
  // const jogetRoleId = audition.jogetRoleId || audition.id;
  const urlSlug = audition.urlSlug || '';
  const projectName = audition.projectName || 'Untitled Project';
  const roleTitle = audition.roleTitle || 'Untitled Role';
  const roleCategory = audition.roleCategory || 'Talent Required';
  const endDate = audition.projectEndDate;
  
  let expiryText = '';

if (endDate) {

  const today = new Date();

  const expiryDate =
    new Date(endDate);

  const diffTime =
    expiryDate - today;

  const diffDays =
    Math.ceil(
      diffTime /
      (1000 * 60 * 60 * 24)
    );

  if (diffDays === 0) {
    expiryText = 'Expires Today';
  }

  else if (diffDays === 1) {
    expiryText = 'Expires Tomorrow';
  }

  else if (diffDays > 1 && diffDays <= 7) {
    expiryText =
      `Expires in ${diffDays} Days`;
  }
}

  // Use the full URL provided by the backend (includes the SVG placeholder)
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(projectName)}&background=050506&color=fff&size=20`;
  const displayImage = audition.projectImageUrl || defaultAvatar;
  const roleCost = audition.roleCost;
  const expirySoon = audition.expirySoon;
  // const finalAmount = audition.finalAmount || 0;
  const finalAmount = Number(
  audition?.roleCost?.totalAmount ||
  audition.finalAmount ||
  audition.final_amount ||
  0
).toFixed(2);
  console.log("CARD DATA =>", audition);
console.log("ROLE COST =>", roleCost);

  const formatType = (text) => {
    if (!text || text === 'N/A') return 'Audition';
    return text.replace(/([A-Z])/g, ' $1').trim();
  };

  const auditionTypes = audition.auditionType && audition.auditionType !== 'N/A'
    ? audition.auditionType.split(';').map((t) => formatType(t))
    : ['Audition'];

  return (
    <Link to={`/audition/${id}/${urlSlug}`} className="audition-card-link">
      {/* <Card className="bms-audition-card"> */}
      <Card className="bms-audition-card bms-mobile-fix-card">

         <div className="bms-strip-bar">

   <div className="bms-strip-left">

  {auditionTypes.map((type, index) => (
    <span
      key={index}
      className="bms-strip-type-badge"
    >
      {type}
    </span>
  ))}

</div>

    <div className="bms-strip-right">
      {roleCategory}
    </div>

  </div>

  <div className="bms-image-wrapper">

    <img
      src={displayImage}
      alt={projectName}
      className="bms-card-image"
    />
        {/* <div className="bms-image-wrapper">
          <img
            src={displayImage}
            alt={projectName}
            className="bms-card-image"
            onError={(e) => {
              e.target.src = defaultAvatar;
            }}
          />

          <div className="bms-top-row">
            <div className="bms-top-badges">
              {auditionTypes.map((type, index) => (
                <span key={index} className="bms-badge-top text-uppercase">
                  {type}
                </span>
              ))}
            </div>
            <span className="bms-category-badge-mobile text-capitalize">
              {roleCategory}
            </span>
          </div>

          <span className="bms-verified-image-icon">
            <Star size={14} fill="#9da3b0" color="#9da3b0" />
          </span>
        </div> */}
        {/* <div className="bms-image-wrapper">
  <img
    src={displayImage}
    alt={projectName}
    className="bms-card-image"
    onError={(e) => {
      e.target.src = defaultAvatar;
    }}
  /> */}

  {/* <div className="bms-top-row">
    <div className="bms-top-badges">
      {auditionTypes.map((type, index) => (
        <span key={index} className="bms-badge-top text-uppercase">
          {type}
        </span>
      ))}
    </div>

    <span className="bms-category-badge-mobile text-capitalize">
      {roleCategory}
    </span>
  </div> */}
{/* <div className="bms-strip-bar">

  <div className="bms-strip-left">
    {auditionTypes.join(' • ')}
  </div>

  <div className="bms-strip-right">
    {roleCategory}
  </div>

</div> */}

  <div className="bms-image-bottom-info bms-image-bottom-info-only-amount">

  <div className="bms-image-amount">
    ₹{finalAmount}
  </div>

</div>

{/* </div> */}

  <span className="bms-verified-image-icon">
    <Star size={14} fill="#9da3b0" color="#9da3b0" />
  </span>
</div>

        {/* <Card.Body className="bms-card-body">
          <h5 className="bms-project-title">{projectName}</h5>
          <p className="bms-role-name">{roleTitle}</p>
        </Card.Body> */}

        <Card.Body className="bms-card-body">

      <h5 className="bms-project-title">
        {projectName}
      </h5>
      <p className="bms-role-name">
        {roleTitle}
      </p>
      <div className="bms-project-dates">

  {expiryText ? (

    <div className="bms-expiry-text">
      {expiryText}
    </div>

  ) : endDate ? (

    <div className="bms-date-item">
      Ends:
      {new Date(endDate)
        .toLocaleDateString('en-GB')}
    </div>

  ) : null}

</div>
    </Card.Body>


      </Card>
    </Link>
  );
};

export default ModernAuditionCard;